/**
 * Copyright 2016 Taito United Oy
 * All rights reserved.
 */

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import styled from 'styled-components';

// Components
import ChatMessageList from './ChatMessageList';
import ChatForm from './ChatForm';
import ReviewsCard from '../review/ReviewsCard';

const propTypes = {
  saveChat: PropTypes.func.isRequired,
  chat: PropTypes.object.isRequired,
  isClient: PropTypes.bool.isRequired,
};

class ChatBox extends PureComponent {
  scrollToBottom = () => {
    if (this.scrollAnchor && this.scrollAnchor.scrollIntoView) {
      setTimeout(() => {
        this.scrollAnchor.scrollIntoView();
      }, 100);
    }
  };

  render() {
    const { chat, isClient } = this.props;
    return (
      <React.Fragment>
        <Top>
          <div>
            <ReviewsCard review={chat.review} />
          </div>
          <div>
            {!!chat.messages.length && (
              <ChatMessageList
                messages={chat.messages}
                company={chat.company}
                review={chat.review}
                scrollToBottom={this.scrollToBottom}
              >
                <div
                  ref={node => {
                    this.scrollAnchor = node;
                  }}
                />
              </ChatMessageList>
            )}
            {/* Empty messagelist */
            !chat.messages.length && (
              <ChatMessageList
                messages={chat.messages}
                company={chat.company}
                review={chat.review}
                scrollToBottom={this.scrollToBottom}
              >
                <div
                  ref={node => {
                    this.scrollAnchor = node;
                  }}
                />
              </ChatMessageList>
            )}
          </div>
        </Top>

        <Bottom>
          <Sender>
            {isClient
              ? chat.review && `${chat.review.name || 'Sinä'}:`
              : chat.company && `${chat.company.name}:`
            }
          </Sender>
          <ChatForm
            id={chat.id}
            messages={chat.messages}
            saveChat={this.props.saveChat}
            onMessageSend={this.scrollToBottom}
          />
        </Bottom>
      </React.Fragment>
    );
  }
}

ChatBox.propTypes = propTypes;

const Top = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;

  & > * {
    margin-bottom: 12px;
  }

  @media (min-width: 720px) {
    flex-direction: row;

    & > * {
      margin-bottom: 0px;
    }

    & > *:first-child {
      flex: 1;
      margin-right: 12px;
      padding: 0;
    }

    & > *:last-child {
      flex: 2;
    }
  }
`;

const Bottom = styled(Top)`
  align-items: center;
  justify-content: flex-end;
`;

const Sender = styled.span`
  font-weight: bold;
  text-align: right;
`;

export default ChatBox;
